import { motion } from "framer-motion";
import { Check, Phone } from "lucide-react";
import { PLANS, SITE } from "../../data/site";

export const Plans = () => (
  <section
    id="plans"
    data-testid="plans-section"
    className="bg-[#F0ECE6] py-24 md:py-32 relative grain-light"
  >
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 relative">
      <div className="grid grid-cols-12 gap-6 mb-14 items-end">
        <div className="col-span-12 lg:col-span-7">
          <div className="text-[#C05746] text-xs md:text-sm font-semibold tracking-[0.24em] uppercase mb-4">
            Protection plans
          </div>
          <h2 className="font-display text-[#1C1B1A] text-4xl md:text-5xl lg:text-[4.5rem] leading-[1.02] tracking-tight">
            Two ways to
            <br />
            <span className="font-serif-accent italic text-[#C05746]">sleep</span> easier.
          </h2>
        </div>
        <p className="col-span-12 lg:col-span-5 text-[#5C5A55] text-base md:text-lg leading-relaxed">
          One-time treatment, ongoing protection, or both — we'll recommend the
          right fit on the phone. No pressure, no surprise pricing.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
        {PLANS.map((p, i) => {
          const dark = i === 1;
          return (
            <motion.div
              key={p.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.65, delay: i * 0.1 }}
              data-testid={`plan-${i}`}
              className={`relative p-8 md:p-12 border ${
                dark
                  ? "bg-[#1E2C25] border-[#2A3B32] text-[#F9F7F4]"
                  : "bg-[#F9F7F4] border-[#E5DFD5] text-[#1C1B1A]"
              }`}
            >
              <div
                className={`text-[10px] uppercase tracking-[0.24em] mb-3 ${
                  dark ? "text-[#C05746]" : "text-[#C05746]"
                }`}
              >
                {p.kicker}
              </div>
              <h3 className="font-display text-3xl md:text-4xl leading-tight tracking-tight">
                {p.name}
              </h3>
              <ul className="mt-8 space-y-4">
                {p.points.map((pt) => (
                  <li
                    key={pt}
                    className={`flex items-start gap-3 text-sm md:text-base leading-relaxed ${
                      dark ? "text-[#F9F7F4]/80" : "text-[#5C5A55]"
                    }`}
                  >
                    <span
                      className={`mt-0.5 w-5 h-5 flex-shrink-0 flex items-center justify-center ${
                        dark ? "bg-[#C05746] text-[#F9F7F4]" : "bg-[#1E2C25] text-[#F9F7F4]"
                      }`}
                    >
                      <Check size={12} strokeWidth={3} />
                    </span>
                    <span>{pt}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-10 pt-8 border-t border-dashed border-[#C05746]/50">
                <a
                  href={SITE.phoneHref}
                  data-testid={`plan-call-button-${i}`}
                  className={`inline-flex items-center gap-3 text-sm font-semibold uppercase tracking-[0.14em] link-underline ${
                    dark ? "text-[#F9F7F4]" : "text-[#1C1B1A]"
                  }`}
                >
                  <Phone size={16} /> Call to discuss
                </a>
              </div>
            </motion.div>
          );
        })}
      </div>

      <p className="text-xs text-[#5C5A55] mt-10 max-w-3xl leading-relaxed">
        <strong className="text-[#1C1B1A]">Warranty Details:</strong> ATC will
        retreat the structure for subterranean termites at no cost if an
        infestation is found, provided all payments are current. The warranty
        renews annually with your inspection. Annual inspections occur between
        April and September each year.
      </p>
    </div>
  </section>
);
